import React from 'react';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  styled,
  Box,
  Button
} from '@mui/material';

import { ApiRequestTable } from 'modules';
import { modalUtil } from 'iron-forge-react-modules';
import * as OverrideLeaseApplicationModal from './OverrideLeaseApplicationModal/OverrideLeaseApplicationModal';
import * as dataService from './dataService';



const SummaryBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2)
}));

export interface IProps {
  orderId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.orderId);
  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers([
    'overrideLeaseApplication'
  ]);



  function handleClickManuallyFulfill(event: React.MouseEvent) {
    // stops the accordion from closing
    event.stopPropagation();
    setModalIsOpen('overrideLeaseApplication', true);
  }



  return (
    <>
      <Accordion>
        <AccordionSummary>
          <SummaryBox>
            <h3>SmartPay Lease Application Information</h3>

            {queryTuple.data.showManualOverrideButton && (
              <Button onClick={handleClickManuallyFulfill}>
                Manually Fulfill Lease
              </Button>
            )}
          </SummaryBox>
        </AccordionSummary>

        <AccordionDetails>
          <ApiRequestTable.FC apiRequests={queryTuple.data.apiRequests} />
        </AccordionDetails>
      </Accordion>

      {modalType2IsOpen.overrideLeaseApplication && (
        <OverrideLeaseApplicationModal.FC
          orderId={queryTuple.data.orderId}
          leaseApplicationId={queryTuple.data.leaseApplicationId}
          onClose={() => setModalIsOpen('overrideLeaseApplication', false)} />
      )}
    </>
  );
};
